export function load(localStorageKey: string, version: number) {
  try {
    let blob: any = localStorage.getItem(localStorageKey)
    if (blob) {
      blob = JSON.parse(blob)
      if (blob.version === version && blob.data) {
        return blob.data
      }
    }
  } catch (err) {
    console.error(
      'failed to load',
      localStorageKey,
      localStorage.getItem(localStorageKey),
    )
  }
}

export function save(localStorageKey: string, version: number, data: any) {
  let blob: any = {
    version,
    data,
  }

  localStorage.setItem(localStorageKey, JSON.stringify(blob))
}
